import { memo } from 'react';

import { LinkIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';

export const CreateShowcaseModalFooter = memo(() => {
  const { onSave, onClose, isSaving, errors, hasCreatedShowcase } = useShowcaseModal();

  if (hasCreatedShowcase) {
    return (
      <div className="flex justify-end">
        <Button
          appearance="filled"
          color="blue"
          data-testid="CREATE_COLLECTION_LINK_DONE_BUTTON"
          onClick={onClose}
          size="large"
          type="button"
        >
          Done
        </Button>
      </div>
    );
  }

  return (
    <div className="flex justify-end gap-2">
      <Button
        appearance="ghost"
        color="gray"
        data-testid="CREATE_COLLECTION_LINK_CANCEL_BUTTON"
        disabled={isSaving}
        onClick={onClose}
        size="large"
        type="button"
      >
        Cancel
      </Button>
      <Button
        appearance="filled"
        color="blue"
        data-testid="CREATE_COLLECTION_LINK_BUTTON"
        disabled={isSaving || !!errors}
        isLoading={isSaving}
        onClick={onSave}
        prefix={<LinkIcon size="sm" />}
        size="large"
        type="button"
      >
        Create showcase
      </Button>
    </div>
  );
});

CreateShowcaseModalFooter.displayName = 'CreateShowcaseModalFooter';
